import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const Gymnastics = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my gymnastics business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps gymnastics businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for gymnastics businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most gymnastics businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my gymnastics business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like gymnastics. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Gymnastics - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Gymnastics CRM", url: "/industries/gymnastics" }
  ];

  const industryData = {
    name: 'Gymnastics Center',
    title: 'Fill Classes & Progress Students to Competitive Teams',
    subtitle: 'Automate enrollment, track skill progression, and build thriving recreational and competitive programs',
    icon: '🤸',
    challenges: [
      'Recreational classes don\'t fill',
      'Hard to identify competitive potential',
      'Parents want constant progress updates',
      'Meet registration is chaotic',
      'Summer camp enrollment is low'
    ],
    solutions: [
      'Automated enrollment campaigns',
      'Skill progression tracking',
      'Parent communication automation',
      'Meet registration management',
      'Summer camp promotion'
    ],
    features: [
      'Student CRM with skill tracking',
      'Class enrollment automation',
      'Progress reports for parents',
      'Meet registration system',
      'Team placement tracking',
      'Payment automation',
      'Video skill analysis',
      'Review requests'
    ],
    results: [
      '95% class capacity',
      '70% rec students stay long-term',
      '3x team program growth',
      '£6.2K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Gymnastics UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for gymnastics businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for gymnastics UK, gymnastics business software, gymnastics customer management, gymnastics lead generation UK"
        url="/industries/gymnastics"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default Gymnastics;